module.exports = __webpack_public_path__ + "produce-fresh-grass-04.jpg?15ce74cc7b70991ff82e428541386408";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-04.jpg
// module id = 41
// module chunks = 0